import { Timestamp } from "firebase/firestore/lite";

import { EntitySource } from "@dashboard/types/source";
import { EntitySourceDocumentField } from "@dashboard/types/source";

// Firestore converter for the entitySource field in the a Dish document.

export const readEntitySource = (
  doc: EntitySourceDocumentField | null
): EntitySource | null => {
  if (!doc) {
    return null;
  }
  return {
    partner: doc.partner,
    partnerId: doc.partnerId,
    lastSyncedAtMillis: doc.lastSyncedAt.toMillis(),
  };
};

export const writeEntitySource = (
  source: EntitySource | null
): EntitySourceDocumentField | null => {
  if (!source) {
    return null;
  }
  return {
    partner: source.partner,
    partnerId: source.partnerId,
    lastSyncedAt: Timestamp.fromMillis(source.lastSyncedAtMillis),
  };
};
